import { useEffect, useState } from 'react';

type Props = {
  open: boolean;
  children: React.ReactNode;
};

export function AnimatedOverlay({ open, children }: Props) {
  const [mounted, setMounted] = useState(false);
  const [animationState, setAnimationState] = useState(false);

  useEffect(() => {
    if (open) {
      // First mount the component
      setMounted(true);

      // Then trigger the animation after a small delay
      // This ensures the component is in the DOM before animation starts
      const timer = setTimeout(() => {
        setAnimationState(true);
      }, 50);
      return () => clearTimeout(timer);
    }
    // First reverse the animation
    setAnimationState(false);

    // Then unmount after animation completes
    const timer = setTimeout(() => {
      setMounted(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [open]);

  if (!mounted) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          opacity: animationState ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      />

      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'white',
          overflow: 'hidden',
          opacity: animationState ? 1 : 0,
          transform: animationState ? 'scale(1)' : 'scale(0.95)',
          transition: 'opacity 0.4s ease, transform 0.4s ease',
        }}
      >
        {children}
      </div>
    </div>
  );
}
